import type { FC } from "react"

type IconProps = { className?: string }

// Toolbar icons drawn in `currentColor` so the dark selection toolbar can tint them via CSS.
// Connect + Trash are the exact Figma paths; Check is a local glyph for the review toggle.

export const ConnectElevationIcon: FC<IconProps> = ({ className }) => (
	<svg className={className} width="15" height="8" viewBox="0 0 15 8" fill="none" aria-hidden>
		<path
			d="M5.26823 7.26628H3.9349C3.05084 7.26628 2.20299 6.91509 1.57787 6.28996C0.952752 5.66484 0.601562 4.817 0.601562 3.93294C0.601562 3.04889 0.952752 2.20104 1.57787 1.57592C2.20299 0.950799 3.05084 0.599609 3.9349 0.599609H5.26823M9.26823 0.599609H10.6016C11.4856 0.599609 12.3335 0.950799 12.9586 1.57592C13.5837 2.20104 13.9349 3.04889 13.9349 3.93294C13.9349 4.817 13.5837 5.66484 12.9586 6.28996C12.3335 6.91509 11.4856 7.26628 10.6016 7.26628H9.26823M4.60156 3.93294H9.9349"
			stroke="currentColor"
			strokeWidth="0.8"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

// Disconnect / detach from elevation (exact Figma glyph — a broken link).
export const DisconnectElevationIcon: FC<IconProps> = ({ className }) => (
	<svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
		<path
			d="M11.8786 8.14232L12.8533 7.17331H12.8419C13.3636 6.63274 13.6495 5.90723 13.6367 5.15608C13.624 4.40493 13.3137 3.68954 12.7739 3.16698C12.2452 2.65709 11.5393 2.37217 10.8048 2.37217C10.0702 2.37217 9.36433 2.65709 8.8356 3.16698L7.86094 4.13598M4.13224 7.85898L3.16324 8.82799C2.64154 9.36856 2.35569 10.0941 2.36844 10.8452C2.38119 11.5964 2.6915 12.3118 3.23124 12.8343C3.75997 13.3442 4.46587 13.6291 5.2004 13.6291C5.93494 13.6291 6.64084 13.3442 7.16957 12.8343L8.13857 11.8653M5.73594 2.33398V4.03398M2.33594 5.73398H4.03594M10.2693 11.9673V13.6673M11.9693 10.2673H13.6693"
			stroke="currentColor"
			strokeWidth="0.8"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export const PlusIcon: FC<IconProps> = ({ className }) => (
	<svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
		<path d="M8 3.5v9M3.5 8h9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
)

export const MinusIcon: FC<IconProps> = ({ className }) => (
	<svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
		<path d="M3.5 8h9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
)

export const CheckIcon: FC<IconProps> = ({ className }) => (
	<svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
		<path d="m3.5 8.5 3 3 6-7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
)

export const TrashIcon: FC<IconProps> = ({ className }) => (
	<svg className={className} width="14" height="15" viewBox="0 0 14 15" fill="none" aria-hidden>
		<path
			d="M0.601562 3.26628H12.6016M11.2682 3.26628V12.5996C11.2682 13.2663 10.6016 13.9329 9.9349 13.9329H3.26823C2.60156 13.9329 1.9349 13.2663 1.9349 12.5996V3.26628M3.9349 3.26628V1.93294C3.9349 1.26628 4.60156 0.599609 5.26823 0.599609H7.9349C8.60156 0.599609 9.26823 1.26628 9.26823 1.93294V3.26628"
			stroke="currentColor"
			strokeWidth="0.8"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
